import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import Router from './routes.js';
import App from './App.js';

export default class Root extends Component {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <Router component={App} />
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object
};
